import { InputSearch } from "components/ui_kit/Input_search";
import React from "react";
import styles from "./header.module.scss";
import { InstitutionalNav } from "./NavInstitutional";
import { NavMiddle } from "./NavMiddle";

interface HeaderProps {
  children?: any;
  optionsTop?: any;
}

export const Header: React.FC<HeaderProps> = ({ children, optionsTop }) => {
  return (
    <div className={styles.box}>
      <InstitutionalNav />
      <NavMiddle />
    </div>
  );
};
